import { client } from './client'
import { AgentMetricsResponse, LoadAgentMetricsPayload } from '@views/agentMetrics/types'

export const getAgentMetrics = async (
  cocap: string,
  filters: LoadAgentMetricsPayload
): Promise<AgentMetricsResponse> => {
  const response = await client.get<AgentMetricsResponse>('/agent-metrics', {
    headers: { cocap },
    params: { period: filters.period, year: filters.year }
  })
  return response.data
}
